import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [signedOut, setSignedOut] = useState(false);
  const [googleError, setGoogleError] = useState("");

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setSignedOut(true);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, logout, signedOut, setSignedOut, googleError, setGoogleError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
